import AbstractRepository from "@/repositories/AbstractRepository";

export default class ParticipationRepository extends AbstractRepository {
    public static defaultFields: string[] = [
        "owner.uuid",
        "owner.fullName",
        "hierarchyOwner.uuid",
        "hierarchyOwner.fullName",
        "hierarchyOwner.clientCode1",
        "hierarchyOwner.brand.fullName",
        "campaign.label",
        "campaign.startDate",
        "campaign.endDate",
        "campaign.formattedWeek",
        "campaign.externalCode",
        "uuid",
        "approvedAt",
        "refusedAt",
        "validationDeadline"
    ];

    protected static resource: string = "ptf-socle-participation";
}
